import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <g clipPath="url(#clip0_2521_704)">
        <path
          fill="currentColor"
          d="M6 0a6 6 0 016 6c0 3.316-2.684 6-6 6S0 9.316 0 6a6 6 0 016-6zm.75 8.25h-1.5v1.5h1.5v-1.5zm0-6h-1.5v4.5h1.5v-4.5z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2521_704">
          <path fill="#fff" d="M0 0H12V12H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
